import {
  OrderTableColumn,
} from '../../../../sources/charting_library.min';
import {
  StandardFormatterName,
} from '../../../../sources/charting_library';
import { ITVOrder } from './types';

type TCustomizedOrderManagerColumn = OrderTableColumn & {
  property: keyof ITVOrder;
};

export const orderTableColumns: TCustomizedOrderManagerColumn[] = [
  {
    id: 'symbol',
    label: 'Symbol',
    property: 'name',
    formatter: StandardFormatterName.Symbol,
    dataFields: ['name', 'name'],
  },
  {
    id: 'segment',
    label: 'Exchange',
    property: 'segment',
    formatter: StandardFormatterName.Text,
    dataFields: ['segment'],
  },
  {
    id: 'status',
    label: 'Status',
    property: 'status',
    formatter: StandardFormatterName.Status,
    dataFields: ['status'],
  },
  {
    id: 'time',
    label: 'Date and Time',
    property: 'time',
    formatter: StandardFormatterName.LocalDate,
    dataFields: ['time'],
  },
  {
    id: 'product',
    label: 'Product',
    property: 'product',
    formatter: StandardFormatterName.Text,
    dataFields: ['product'],
  },
  {
    id: 'side',
    label: 'Side',
    property: 'side',
    formatter: StandardFormatterName.Side,
    dataFields: ['side'],
  },
  {
    id: 'qty',
    label: 'Qty',
    property: 'qty',
    formatter: StandardFormatterName.FormatQuantity,
    alignment: 'right',
    dataFields: ['qty'],
  },
  {
    id: 'quantityTraded',
    label: 'Traded qty',
    property: 'quantityTraded',
    formatter: StandardFormatterName.FormatQuantity,
    alignment: 'right',
    dataFields: ['quantityTraded'],
  },
  {
    id: 'priceLimit',
    label: 'Limit Price',
    property: 'priceLimit',
    showZeroValues: false,
    alignment: 'right',
    sortProp: 'limitPrice',
    dataFields: ['priceLimit'],
  },
  {
    id: 'priceTraded',
    label: 'Traded Price',
    property: 'priceTraded',
    showZeroValues: false,
    alignment: 'right',
    sortProp: 'avgPrice',
    dataFields: ['priceTraded'],
  },

  {
    id: 'customMessage',
    label: 'Rejection Reason',
    property: 'customMessage',
    formatter: StandardFormatterName.Text,
    dataFields: ['customMessage'],
  },
  {
    id: 'type',
    label: 'Order Type',
    property: 'type',
    formatter: StandardFormatterName.Type,
    dataFields: ['type', 'parentId', 'stopType'],
  },
  {
    id: 'priceTrigger',
    label: 'Trigger Price',
    property: 'priceTrigger',
    showZeroValues: false,
    alignment: 'right',
    sortProp: 'stopPrice',
    dataFields: ['priceTrigger'],
  },
  {
    id: 'orderNumberOms',
    label: 'Order Number',
    property: 'orderNumberOms',
    formatter: StandardFormatterName.Text,
    dataFields: ['orderNumberOms'],
  },
  {
    id: 'orderNumberExchange',
    label: 'Exchange Order Number',
    property: 'orderNumberExchange',
    formatter: StandardFormatterName.Text,
    dataFields: ['orderNumberExchange'],
  },
];

export const fnoProductTypes = [
  {
    text: 'Delivery',
    value: 'D',
  },
  {
    text: 'Intraday',
    value: 'I',
  },
];

export const productTypes = (type: string) =>
  (type === 'I'
    ? [
        {
          text: 'Intraday',
          value: 'I',
        },
        {
          text: 'Delivery',
          value: 'D',
        },
      ]
    : [
        {
          text: 'Delivery',
          value: 'D',
        },
        {
          text: 'Intraday',
          value: 'I',
        },
      ]);

export const orderFormCustomFields = (
  isFno: boolean,
  lastProductSelection: string,
) => [
  {
    inputType: 'ComboBox',
    title: 'Product type',
    id: 'productType',
    preventModify: true,
    items: isFno ? fnoProductTypes : productTypes(lastProductSelection),
  },
];
